module.exports = __webpack_public_path__ + "static/img/109.1503b2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/109.png
// module id = Ylrf
// module chunks = 0